/* eslint no-console:0 */

import 'jquery';
import 'bootstrap';
import Rails from "@rails/ujs"

Rails.start()

import '../modules/phone-country-code-select.js'
